{
  "AUTOMATION": {
    "HEADER": "Automatització",
    "DESCRIPTION": "Automation can replace and streamline existing processes that require manual effort, such as adding labels and assigning conversations to the most suitable agent. This allows the team to focus on their strengths while reducing time spent on routine tasks.",
    "LEARN_MORE": "Learn more about automation",
    "HEADER_BTN_TXT": "Afegeix una regla d'automatització",
    "LOADING": "S'estan recollint regles d'automatització",
    "ADD": {
      "TITLE": "Afegeix una regla d'automatització",
      "SUBMIT": "Crear",
      "CANCEL_BUTTON_TEXT": "Cancel·la",
      "FORM": {
        "NAME": {
          "LABEL": "Nom de la regla",
          "PLACEHOLDER": "Introdueix el nom de la regla",
          "ERROR": "El valor és necessari"
        },
        "DESC": {
          "LABEL": "Descripció",
          "PLACEHOLDER": "Introdueix la descripció de la regla",
          "ERROR": "La descripció és necessària"
        },
        "EVENT": {
          "LABEL": "Esdeveniment",
          "PLACEHOLDER": "Selecciona un",
          "ERROR": "És necessari un esdeveniment"
        },
        "PHASE": {
          "LABEL": "Fase"
        },
        "ORDER": {
          "LABEL": "Ordre",
          "ERROR": "L'ordre és obligatori"
        },
        "CONDITIONS": {
          "LABEL": "Condicions"
        },
        "ACTIONS": {
          "LABEL": "Accions"
        }
      },
      "CONDITION_BUTTON_LABEL": "Afegeix condició",
      "ACTION_BUTTON_LABEL": "Afegeix acció",
      "API": {
        "SUCCESS_MESSAGE": "La regla d'automatització s'ha afegit correctament",
        "ERROR_MESSAGE": "No s'ha pogut crear una regla d'automatització. Intenta-ho més tard"
      }
    },
    "LIST": {
      "TABLE_HEADER": {
        "PHASE": "Fase",
        "ORDER": "Ordre",
        "NAME": "Nom",
        "DESCRIPTION": "Descripció",
        "ACTIVE": "Actiu",
        "CREATED_ON": "Creat el",
        "WAIT": "Espera"
      },
      "404": "No s'han trobat regles d'automatització",
      "TABS": {
        "ALL": "Totes",
        "INSTANT": "En l'esdeveniment",
        "DELAYED": "Amb retard"
      },
      "WAITS": "Espera {duration}"
    },
    "DELETE": {
      "TITLE": "Suprimeix una regla d'automatització",
      "SUBMIT": "Esborrar",
      "CANCEL_BUTTON_TEXT": "Cancel·la",
      "CONFIRM": {
        "TITLE": "Confirma l'esborrat",
        "MESSAGE": "N'estas segur? ",
        "YES": "Si, esborra ",
        "NO": "No, segueix "
      },
      "API": {
        "SUCCESS_MESSAGE": "La regla d'automatització s'ha suprimit correctament",
        "ERROR_MESSAGE": "No s'ha pogut suprimir una regla d'automatització. Intenta-ho més tard"
      }
    },
    "EDIT": {
      "TITLE": "Edita una regla d'automatització",
      "SUBMIT": "Actualitza",
      "CANCEL_BUTTON_TEXT": "Cancel·la",
      "API": {
        "SUCCESS_MESSAGE": "La regla d'automatització s'ha actualitzat correctament",
        "ERROR_MESSAGE": "No s'ha pogut actualitzar una regla d'automatització. Intenta-ho més tard"
      }
    },
    "CLONE": {
      "TOOLTIP": "Clona",
      "API": {
        "SUCCESS_MESSAGE": "L'automatització s'ha clonat correctament",
        "ERROR_MESSAGE": "No s'ha pogut clonar una regla d'automatització. Intenta-ho més tard"
      }
    },
    "FORM": {
      "EDIT": "Edita",
      "CREATE": "Crear",
      "DELETE": "Esborrar",
      "CANCEL": "Cancel·la",
      "RESET_MESSAGE": "Si canvies el tipus d'esdeveniment, es restabliran les condicions i els esdeveniments que has afegit a continuació"
    },
    "CONDITION": {
      "DELETE_MESSAGE": "Necessites almenys una condició per desar",
      "CONTACT_CUSTOM_ATTR_LABEL": "Contacta amb Atributs personalitzats",
      "CONVERSATION_CUSTOM_ATTR_LABEL": "Atributs personalitzats de conversa"
    },
    "ACTION": {
      "DELETE_MESSAGE": "Necessites almenys una acció per desar",
      "TEAM_MESSAGE_INPUT_PLACEHOLDER": "Introdueix el teu missatge aquí",
      "TEAM_DROPDOWN_PLACEHOLDER": "Selecciona els equips",
      "EMAIL_INPUT_PLACEHOLDER": "Enter email",
      "URL_INPUT_PLACEHOLDER": "Enter URL",
      "SENDER_DROPDOWN_PLACEHOLDER": "Selecciona la safata d'entrada de correu electrònic i l'adreça de remitent",
      "SUBJECT_INPUT_PLACEHOLDER": "Assumpte del correu electrònic",
      "SMS_INBOX_DROPDOWN_PLACEHOLDER": "Selecciona la safata d'entrada d'SMS des de la qual s'enviarà",
      "SMS_MESSAGE_INPUT_PLACEHOLDER": "Introdueix el text de l'SMS",
      "SMS_COUNTER": "{length}/{limit} caràcters, {segments} SMS (abans d'omplir les variables)"
    },
    "TOGGLE": {
      "ACTIVATION_TITLE": "Activa la regla d'automatització",
      "DEACTIVATION_TITLE": "Desactiva la regla d'automatització",
      "ACTIVATION_DESCRIPTION": "Aquesta acció activarà la regla d'automatització '{automationName}'. Estàs segur que vols continuar?",
      "DEACTIVATION_DESCRIPTION": "Aquesta acció desactivarà la regla d'automatització '{automationName}'. Estàs segur que vols continuar?",
      "ACTIVATION_SUCCESFUL": "La regla d'automatització s'ha activat correctament",
      "DEACTIVATION_SUCCESFUL": "La regla d'automatització s'ha desactivat correctament",
      "ACTIVATION_ERROR": "No s'ha pogut activar l'automatització. Intenta-ho més tard",
      "DEACTIVATION_ERROR": "No s'ha pogut desactivar l'automatització. Intenta-ho més tard",
      "CONFIRMATION_LABEL": "Si",
      "CANCEL_LABEL": "No"
    },
    "ATTACHMENT": {
      "UPLOAD_ERROR": "No s'ha pogut carregar el fitxer adjunt. Torna-ho a provar",
      "LABEL_IDLE": "Puja fitxer adjunt",
      "LABEL_UPLOADING": "S'està carregant...",
      "LABEL_UPLOADED": "S'ha pujat correctament",
      "LABEL_UPLOAD_FAILED": "Ha fallat la pujada"
    },
    "ERRORS": {
      "ATTRIBUTE_KEY_REQUIRED": "Attribute key is required",
      "FILTER_OPERATOR_REQUIRED": "Filter operator is required",
      "VALUE_REQUIRED": "El valor és necessari",
      "VALUE_MUST_BE_BETWEEN_1_AND_998": "Value must be between 1 and 998",
      "ACTION_PARAMETERS_REQUIRED": "Action parameters are required",
      "ATLEAST_ONE_CONDITION_REQUIRED": "At least one condition is required",
      "ATLEAST_ONE_ACTION_REQUIRED": "At least one action is required"
    },
    "ACTION_NOTICES": {
      "SKIP_AUTO_PRIORITY": "Aquesta acció només funciona quan la fase de la regla és 'Abans de l'etiquetatge'.",
      "SKIP_AUTO_LABELING": "Aquesta acció només funciona quan la fase de la regla és 'Abans de l'etiquetatge'.",
      "MOVE_CONVERSATION_TO_INBOX": "Només les converses de correu electrònic i de xat web es poden moure a una safata d'entrada de correu electrònic, i un xat web només si el contacte té adreça de correu electrònic. Altrament, la conversa es queda on és i, en lloc d'això, s'afegeix una nota privada.",
      "SEND_MESSAGE_IN_NEW_CONVERSATION": "Inicia una conversa nova amb el contacte a la safata d'entrada de correu electrònic seleccionada, li envia el missatge per correu electrònic i resol la conversa. Això passa cada vegada que s'executa la regla. Si el contacte no té adreça de correu electrònic, no s'envia res i s'afegeix una nota privada.",
      "SEND_SMS_IN_NEW_CONVERSATION": "Inicia una conversa nova amb el contacte a la safata d'entrada d'SMS seleccionada, li envia el missatge per SMS i resol la conversa. Això passa cada vegada que s'executa la regla. El missatge és text sense format i sense fitxers adjunts. Si el contacte no té número de telèfon, no s'envia res i s'afegeix una nota privada."
    },
    "NOTICES": {
      "AI_PROMPT": "Cada avaluació individual té un cost.",
      "INCOMING_MESSAGES_COUNT": "Es refereix al nombre de missatges entrants a la conversa.",
      "OUTGOING_MESSAGES_COUNT": "Es refereix al nombre de missatges sortints a la conversa."
    },
    "PHASE": {
      "BEFORE_LABELING": "Abans de l'etiquetatge",
      "AFTER_LABELING": "Després de l'etiquetatge"
    },
    "NONE_OPTION": "Ningú",
    "MESSAGE_TYPE_VALUES": {
      "INCOMING": "Incoming Message",
      "OUTGOING": "Outgoing Message",
      "PRIVATE": "Private Note",
      "AI_SUMMARY": "AI Summary"
    },
    "YES_NO_VALUES": {
      "YES": "Sí",
      "NO": "No"
    },
    "MESSAGE_SOURCE_TYPE_VALUES": {
      "FACEBOOK_MESSENGER": "Facebook Messenger",
      "INSTAGRAM_DM": "Missatge directe d'Instagram",
      "FACEBOOK_COMMENT": "Comentari de Facebook"
    },
    "EVENTS": {
      "CONVERSATION_CREATED": "Conversa creada",
      "CONVERSATION_UPDATED": "Conversa actualitzada",
      "MESSAGE_CREATED": "Missatge creat",
      "CONVERSATION_OPENED": "Conversa oberta",
      "CONVERSATION_RESOLVED": "Conversa resolta",
      "PHONE_CALL_FINISHED": "Trucada finalitzada"
    },
    "ACTIONS": {
      "ASSIGN_AGENT": "Assigna a un agent",
      "ASSIGN_TEAM": "Assigna a un equip",
      "ADD_LABEL": "Afegeix una etiqueta",
      "REMOVE_LABEL": "Elimina una etiqueta",
      "SEND_EMAIL_TO_TEAM": "Envia un correu electrònic a l'equip",
      "SEND_EMAIL_TRANSCRIPT": "Envia una transcripció per correu electrònic",
      "SEND_EMAIL_TRANSCRIPT_WITH_DETAILS": "Envia una transcripció detallada per correu electrònic",
      "MUTE_CONVERSATION": "Silencia la conversa",
      "SNOOZE_CONVERSATION": "Posposa la conversa",
      "RESOLVE_CONVERSATION": "Resol la conversa",
      "OPEN_CONVERSATION": "Obre la conversa",
      "SEND_WEBHOOK_EVENT": "Envia un esdeveniment de webhook",
      "SEND_ATTACHMENT": "Envia un adjunt",
      "SEND_MESSAGE": "Envia un missatge",
      "ADD_NOTE": "Afegeix una nota",
      "CHANGE_PRIORITY": "Canvia la prioritat",
      "ADD_SLA": "Afegeix un SLA",
      "SKIP_AUTO_PRIORITY": "Omet la prioritat automàtica",
      "SKIP_AUTO_LABELING": "Omet l'etiquetatge automàtic",
      "AUTO_TRANSLATE": "Tradueix el missatge",
      "AUTO_TRANSLATE_CONVERSATION": "Tradueix la conversa",
      "MOVE_CONVERSATION_TO_INBOX": "Mou la conversa a una safata d'entrada",
      "SEND_MESSAGE_IN_NEW_CONVERSATION": "Envia un missatge en una conversa nova",
      "SEND_SMS_IN_NEW_CONVERSATION": "Envia un SMS en una conversa nova",
      "STOP_PROCESSING_RULES": "Atura el processament de regles"
    },
    "ATTRIBUTES": {
      "AI_FILTER": "Filtre d'IA",
      "MESSAGE_TYPE": "Tipus de missatge",
      "MESSAGE_CONTAINS": "Contingut del missatge",
      "EMAIL": "Correu electrònic",
      "INBOX": "Safata d'entrada",
      "CHANNEL_TYPE": "Tipus de safata d'entrada",
      "CONVERSATION_LANGUAGE": "Idioma de la conversa",
      "PHONE_NUMBER": "Número de telèfon",
      "STATUS": "Estat",
      "BROWSER_LANGUAGE": "Idioma del navegador",
      "MAIL_SUBJECT": "Assumpte del correu",
      "COUNTRY_NAME": "País",
      "MARKETPLACE_COUNTRY": "País del marketplace",
      "REFERER_LINK": "Enllaç de referència",
      "ASSIGNEE_NAME": "Assignat",
      "TEAM_NAME": "Equip",
      "PRIORITY": "Prioritat",
      "CALL_DIRECTION": "Direcció de la trucada",
      "MISSED_CALL": "Trucada perduda",
      "MISSED_CALL_COUNT": "Nombre de trucades perdudes",
      "MESSAGE_SOURCE_TYPE": "Tipus d'origen del missatge",
      "INCOMING_MESSAGE_COUNT": "Nombre de missatges entrants",
      "OUTGOING_MESSAGE_COUNT": "Nombre de missatges sortints",
      "LABEL": "Etiqueta",
      "EMAIL_RECIPIENTS": "Destinatari del correu",
      "EMAIL_AUTO_REPLY": "El correu és una resposta automàtica",
      "ATTACHMENT_EXTENSION": "Extensió de l'adjunt",
      "EXTENSION": "Extensió trucada",
      "WORKING_HOURS": "Dins de l'horari laboral",
      "AGENT_REPLIED": "Un agent ha respost des del canvi d'estat"
    },
    "WAIT": {
      "RUN_LABEL": "Executa les accions",
      "INSTANT": "En l'esdeveniment",
      "DELAYED": "Amb retard",
      "TRIGGER_LABEL": "Espera fins que",
      "TRIGGERS": {
        "CONVERSATION_STATUS": "Una conversa es manté en un estat",
        "CUSTOMER_UNRESPONSIVE": "El client no respon a un agent",
        "AGENT_UNRESPONSIVE": "El client no rep resposta d'un agent"
      },
      "STATUS_LABEL": "Estat",
      "STATUSES": {
        "OPEN": "Oberta",
        "PENDING": "Pendent",
        "SNOOZED": "Posposada",
        "RESOLVED": "Resolta"
      },
      "DELAY_LABEL": "Temps d'espera",
      "DELAY_ERROR": "Introdueix una espera d'entre 1 minut i 30 dies",
      "DURATION": {
        "MINUTES": "{count} min",
        "HOURS": "{count} h",
        "DAYS": "{count} d"
      },
      "EXPLANATION": {
        "CONVERSATION_STATUS": "Les accions s'executen quan una conversa ha estat en l'estat {status} durant {duration}. Un canvi d'estat abans les cancel·la. Les etiquetes, l'horari laboral i les respostes dels agents es comproven quan acaba l'espera.",
        "CUSTOMER_UNRESPONSIVE": "Les accions s'executen quan el client no ha respost durant {duration} després del missatge d'un agent. Una resposta del client les cancel·la; un missatge nou de l'agent reinicia l'espera.",
        "AGENT_UNRESPONSIVE": "Les accions s'executen quan el client ha esperat {duration} sense resposta d'un agent. Una resposta de l'agent les cancel·la."
      }
    }
  }
}
